import { render, staticRenderFns } from "./ServicioView.vue?vue&type=template&id=2fcd5693&"
import script from "./ServicioView.vue?vue&type=script&lang=js&"
export * from "./ServicioView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports